define('components/TaggedWith',[
    "jquery",
    "logging",
    "utilities"
], function ($, logging, utilities) {
    var _ModuleName = "Tagged With";

    var _config = {
        maxHeight: 75,
        windowClass: 'faded-window'
    }

    function TaggedWith(scope) {
        "use strict";

        var $taglist = $("ul", scope);
        var $tags = $("li", $taglist);

        var limit = utilities.IsPhone() ? 3 : 5;
        ;

        if($tags.length > limit) {
            ;

            // Hide tags beyond limit
            $tags.each(function(index, tag) {
                if(index > limit) {
                    $(tag).hide();
                }
            });

            // Add more button
            $taglist.append("<li class='read-more'><a href='#'>...more</a></li>");

            // Configure more button
            var $readmore = $('.read-more a', $taglist);
            if($readmore.length) {

                $readmore.click(function( evt ) {
                    evt.stopPropagation && evt.stopPropagation();
                    evt.preventDefault && evt.preventDefault();

                    // Bitwise XOR operator used for toggle
                    var io = this.io ^= 1;

                    if (io == 1) {
                        ;
                        $readmore.html("...less");
                        $tags.show();

                    } else {
                        ;
                        $readmore.html("...more");
                        
                        // Hide tags beyond limit
                        $tags.each(function(index, tag) {
                            if(index > limit) {
                                $(tag).hide();
                            }
                        });

                    }

                });

            } else {
                logging.error("Failed to get handle on read more link to expand tags", _ModuleName);
            }
        }

        ;
    }

    /**
     * Initialize component JavaScript
     * @param {*} args 
     */
    return {
        init: function init(args) {
            ;
            return new TaggedWith(args.scope);
        }
    }
});



